import type { DefinedInitialDataOptions } from '@tanstack/react-query';

export const UseQueryDefaultOptions = {
  throwOnError: true,
  refetchOnWindowFocus: false,
  refetchInterval: false,
  refetchOnMount: false,
  retry: 2,
  retryDelay: 0,
} as const satisfies Pick<
  DefinedInitialDataOptions,
  'throwOnError' | 'retry' | 'retryDelay' | 'refetchOnWindowFocus' | 'refetchInterval' | 'refetchOnMount'
>;

export const UseMutationDefaultOptions = {
  retry: false,
} as const satisfies Pick<DefinedInitialDataOptions, 'retry'>;
